import axios from 'axios';

interface EmailData {
  to_email: string;
  from_name: string;
  from_email: string;
  phone?: string;
  insurance_company?: string;
  annuity_product?: string;
  year_purchased?: string;
  current_age?: string;
  initial_investment?: string;
  primary_goal?: string;
  message: string;
}

// Service to handle email sending
export const emailService = {
  // Send email via backend API
  async sendViaAPI(data: EmailData): Promise<void> {
    try {
      // Format data for the API endpoint
      const apiData = {
        data: {
          to_email: data.to_email,
          from_name: data.from_name,
          from_email: data.from_email,
          phone: data.phone || 'Not provided',
          insurance_company: data.insurance_company || 'Not provided',
          annuity_product: data.annuity_product || 'Not provided',
          year_purchased: data.year_purchased || new Date().getFullYear().toString(),
          current_age: data.current_age || 'N/A',
          initial_investment: data.initial_investment || 'Not provided',
          primary_goal: data.primary_goal || 'Not provided',
          message: data.message
        }
      };
      
      // Send to the API endpoint
      const response = await axios.post('/api/send-email', apiData);
      
      if (response.status !== 200) {
        throw new Error('Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email via API:', error);
      throw error;
    }
  },
  
  // Format email data for display
  formatEmailContent(data: any): EmailData {
    return {
      to_email: 'jake@averillagencies.com',
      from_name: data.fullName || data.from_name,
      from_email: data.email || data.from_email,
      phone: data.phone || 'Not provided',
      insurance_company: data.insuranceCompany || data.insurance_company || 'Not provided',
      annuity_product: data.annuityProduct || data.annuity_product || 'Not provided',
      year_purchased: data.yearPurchased || data.year_purchased || 'N/A',
      current_age: data.currentAge || data.current_age || 'N/A',
      initial_investment: data.initialInvestment || 'Not provided',
      primary_goal: data.primaryGoal || 'Not provided',
      message: data.message || `
New Annuity Analysis Request

Contact Information:
Name: ${data.fullName}
Email: ${data.email}
Phone: ${data.phone || 'Not provided'}

Annuity Details:
Insurance Company: ${data.insuranceCompany || 'Not provided'}
Annuity Product: ${data.annuityProduct || 'Not provided'}
Year Purchased: ${data.yearPurchased}
Current Age: ${data.currentAge}
Initial Investment: ${data.initialInvestment || 'Not provided'}
Primary Goal: ${data.primaryGoal || 'Not provided'}

Submitted on: ${new Date().toLocaleString()}
      `.trim()
    };
  }
};